/**
 * Categoria que tem atendimento por chat (Head Account). Público do widget do
 * Zendesk e dos botões de chat do FAB e do menu lateral.
 */
export const CATEGORIA_COM_CHAT = 1;

/**
 * Id numérico de `user.categoriaCliente`, ou `0` quando o usuário não tem
 * categoria ou o id não é numérico. O id chega como string no `ls.user`
 * (ex.: `{ id: '1' }`).
 */
export function getCategoriaCliente(user: any): number {
  const id = user && user.categoriaCliente ? parseInt(user.categoriaCliente.id, 10) : 0;

  return isNaN(id) ? 0 : id;
}

/** O usuário é de uma categoria com atendimento por chat. */
export function temChat(user: any): boolean {
  return getCategoriaCliente(user) === CATEGORIA_COM_CHAT;
}
